module.exports = __webpack_public_path__ + "static/media/Winchester-1.84589187.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-la/Winchester-1.jpg
// module id = 430
// module chunks = 0